import { useState, useEffect } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isPortrait: boolean;
  width: number;
  height: number;
  aspectRatio: number;
  userAgent: string;
}

const TABLET_MIN_WIDTH = 600;
const TABLET_MAX_WIDTH = 1024;
const MOBILE_MAX_WIDTH = 599;

function isTabletUserAgent(ua: string): boolean {
  return /iPad|Tablet|PlayBook|Silk|Nexus 7|Nexus 9/i.test(ua) ||
         (/Android/i.test(ua) && !/Mobile/i.test(ua));
}

export function useDeviceDetect(): DeviceInfo {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isPortrait: true,
    width: 0,
    height: 0,
    aspectRatio: 0,
    userAgent: '',
  });

  useEffect(() => {
    function detectDevice() {
      if (typeof window === 'undefined') return;

      const ua = navigator.userAgent || '';
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isPortrait = height >= width;

      let isTablet = false;
      let isMobile = false;
      let isDesktop = false;

      const uaTablet = isTabletUserAgent(ua);

      if (uaTablet) {
        isTablet = true;
      } else if (width >= TABLET_MIN_WIDTH && width <= TABLET_MAX_WIDTH) {
        isTablet = true;
      } else if (width <= MOBILE_MAX_WIDTH) {
        isMobile = true;
      } else {
        // Large screen
        if (width > TABLET_MAX_WIDTH) {
          // Even on portrait large screens treat as tablet if fitting criteria (if needed)
          if (isPortrait && width >= TABLET_MIN_WIDTH && width <= TABLET_MAX_WIDTH) {
            isTablet = true;
          } else {
            isDesktop = true;
          }
        } else {
          isDesktop = true;
        }
      }

      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        isPortrait,
        width,
        height,
        aspectRatio: width / height,
        userAgent: ua,
      });
    }

    detectDevice();

    window.addEventListener('resize', detectDevice);
    window.addEventListener('orientationchange', detectDevice);

    return () => {
      window.removeEventListener('resize', detectDevice);
      window.removeEventListener('orientationchange', detectDevice);
    };
  }, []);

  return deviceInfo;
}
